/**
 * @generated SignedSource<<8df78c0c239a1787e2976d704620020b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utils_unfinishedMovement$data = {
  readonly id: string;
  readonly stepToClose: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "utils_unfinishedMovement";
};
export type utils_unfinishedMovement$key = {
  readonly " $data"?: utils_unfinishedMovement$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_unfinishedMovement">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "utils_unfinishedMovement"
};

(node as any).hash = "83a6d63664a3ee191cfeb70b7d6390cb";

export default node;
